import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ENDPOINT } from "../../config";
import { VisitorResponse } from "../../interfaces/visitor.interface";

export const visitorApi = createApi({
  reducerPath: "visitorApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT,
  }),
  endpoints: (build) => ({
 
    // GET to fetch unique visitor count
    getVisitorCount: build.query<VisitorResponse, void>({
      query: () => ({
        url: "/visitor",
        method: "GET",
      }),
    }),
  }),
});

export const {useGetVisitorCountQuery } = visitorApi;
